export default {"src":"/_next/static/media/feedback.88cec0cc.svg","height":32,"width":32};